import { render, staticRenderFns } from "./InvestmentStrategyInitialBalance.vue?vue&type=template&id=52668fac&scoped=true&"
import script from "./InvestmentStrategyInitialBalance.vue?vue&type=script&lang=ts&"
export * from "./InvestmentStrategyInitialBalance.vue?vue&type=script&lang=ts&"
import style0 from "./InvestmentStrategyInitialBalance.vue?vue&type=style&index=0&id=52668fac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52668fac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VForm,VRow,VSlider,VTextField})
